import { ServicioCampoDto, ServicioItemDto } from "../../../shared/response/ventas/ServiciosResponse";
import { PipelineService } from "../../services/ventas/PipelineService";

const FALLBACK: ServicioItemDto[] = [
  { id: "dataag",  nombre: "DATA AG",   descripcion: "Monitoreo · Ganadería · Cultivos", tipo: "SOFTWARE", unidad: "ha",      configurable: false, campos: null, orden: 1 },
  { id: "rastro",  nombre: "RASTRO GPS", descripcion: "Rastreo satelital de drones",      tipo: "EQUIPO",   unidad: "unidad", configurable: true,  campos: [{ clave: "unidades", tipo: "numero", min: 1, label: "Unidades", opciones: null, fuente: null }], orden: 2 },
  { id: "bascula", nombre: "BÁSCULA",    descripcion: "Báscula conectada",                tipo: "EQUIPO",   unidad: "unidad", configurable: true,  campos: [{ clave: "unidades", tipo: "numero", min: 1, label: "Unidades", opciones: null, fuente: null }], orden: 3 },
  { id: "vista",   nombre: "VISTA",      descripcion: "Fotogrametría",                    tipo: "SERVICIO", unidad: "km+ha",  configurable: true,  campos: [
    { clave: "km", tipo: "numero", min: 0, label: "Km de distancia", opciones: null, fuente: null },
    { clave: "tipo_vuelo", tipo: "select", min: null, label: "Tipo de vuelo", opciones: ["agricultura", "ganadería"], fuente: null },
    { clave: "arboles", tipo: "select", min: null, label: "Conteo de árboles", opciones: ["no", "si"], fuente: null },
  ], orden: 4 },
  { id: "protec",  nombre: "PROTEC",     descripcion: "Aspersión con drones",             tipo: "SERVICIO", unidad: "ha",      configurable: true,  campos: [
    { clave: "categoria", tipo: "select", min: null, label: "Categoría", opciones: null, fuente: "precios.protec" },
    { clave: "hectareas", tipo: "numero", min: 10, label: "Hectáreas (mín. 10)", opciones: null, fuente: null },
  ], orden: 5 },
];

/** Retorna la lista de servicios activos (API o fallback hardcodeado). */
export function getServicios(): ServicioItemDto[] {
  return PipelineService.instance.servicios?.data ?? FALLBACK;
}

/** Retorna el metadata de un servicio por su ID. */
export function getServicio(id: string): ServicioItemDto | undefined {
  return getServicios().find(s => s.id === id);
}

/** Lee el label de tag (SOFTWARE/EQUIPO/SERVICIO) para un tipo de servicio. */
export function getTagLabel(tipo: string): string {
  if (tipo === "SOFTWARE") return "SOFTWARE";
  if (tipo === "EQUIPO")   return "EQUIPO";
  return "SERVICIO";
}

/**
 * Renderiza el HTML de un campo configurable.
 * `prefix` se usa como base para el id del input (ej: "pl-c-dataag").
 * `preciosHtml` se inyecta en selects con fuente "precios.protec" (opcional).
 */
export function renderCampoHTML(campo: ServicioCampoDto, prefix: string, preciosHtml?: string): string {
  const id = `${prefix}-${campo.clave}`;
  switch (campo.tipo) {
    case "select": {
      const opts = campo.opciones
        ? campo.opciones.map(o => `<option value="${o}">${o}</option>`).join("")
        : (preciosHtml ?? `<option value="">Cargando…</option>`);
      return `<select id="${id}" class="sx-input" style="margin-bottom:4px;" data-campo="${campo.clave}"><option value="">${campo.label}</option>${opts}</select>`;
    }
    case "numero":
      return `<input id="${id}" class="sx-input" type="number" placeholder="${campo.label}" data-campo="${campo.clave}" ${campo.min != null ? `min="${campo.min}"` : ""}>`;
    default:
      return `<input id="${id}" class="sx-input" type="text" placeholder="${campo.label}" data-campo="${campo.clave}">`;
  }
}

/**
 * Renderiza el HTML del wrapper de campos configurables para un servicio.
 * `preciosHtml` se inyecta en selects con fuente "precios.protec".
 */
export function renderServicioFieldsHTML(s: ServicioItemDto, prefix: string, preciosHtml?: string): string {
  if (!s.configurable || !s.campos?.length) return "";
  let inner = "";
  for (const campo of s.campos) {
    const ph = campo.fuente === "precios.protec" ? preciosHtml : undefined;
    inner += renderCampoHTML(campo, prefix, ph);
  }
  return `<div id="${prefix}-wrap" style="display:none;margin-top:6px;">${inner}</div>`;
}

/**
 * Renderiza el HTML de una card de producto (para la cotización).
 * `preciosHtml` se inyecta en selects con fuente "precios.protec" (p.ej. las opciones de PROTEC).
 */
export function renderServicioCardHTML(s: ServicioItemDto, prefix: string, preciosHtml?: string): string {
  const nombre = s.nombre.toUpperCase();
  const fieldsHTML = renderServicioFieldsHTML(s, prefix, preciosHtml);
  const extraStyle = s.id === "protec" ? ' style="grid-column:1/-1"' : "";
  return `<div class="pl-cprod${s.id === "dataag" ? " active" : ""}" id="${prefix}" data-servicio-id="${s.id}"${extraStyle}>
    <div class="pl-cprod-name">${nombre}</div>
    <div class="pl-cprod-sub">${s.descripcion}</div>
    ${s.id === "dataag" ? `<div class="pl-cprod-price" id="${prefix}-price">—</div>` : ""}
    ${fieldsHTML}
  </div>`;
}
